<template>
  <div class="equipment-rhlist">
    <h2 class="top-title">润滑点管理</h2>
    <!-- <Card dis-hover> -->
    <ul class="common-search li-margin">
      <li>
        <span>设备名称: </span>
        <Input
          v-model="dataForm.deviceName"
          @on-search="(e) => searchInput(e, 'deviceName')"
          search
          name="deviceName"
          placeholder="请输入"
        />
      </li>
      <li>
        <span>润滑点名称: </span>
        <Input
          v-model="dataForm.name"
          name="name"
          @on-search="(e) => searchInput(e, 'name')"
          search
          placeholder="请输入"
        />
      </li>
      <li>
        <span>润滑点编号: </span>
        <Input
          v-model="dataForm.oilSiteIotName"
          @on-search="(e) => searchInput(e, 'oilSiteIotName')"
          search
          placeholder="请输入"
        />
      </li>
      <li v-if="userRole.indexOf('c') < 0">
        <span>客户名称: </span>
        <Input
          v-model="dataForm.consumerName"
          @on-search="(e) => searchInput(e, 'consumerName')"
          search
          placeholder="请输入"
        />
      </li>
      <li v-if="userRole.indexOf('c') < 0">
        <span>客户行业: </span>
        <Select
          v-model="dataForm.customerIndustryId"
          @on-change="(e) => changeSel(e, 'customerIndustryId')"
          :clearable="true"
          placeholder="全部"
        >
          <OptionGroup
            :label="con.value"
            :key="con.id"
            v-for="con in dataCenter.consumerIndustry"
          >
            <Option
              :key="con2.id"
              :value="con2.id"
              v-for="con2 in con.children"
              >{{ con2.value }}</Option
            >
          </OptionGroup>
        </Select>
      </li>
      <li>
        <span>设备类型: </span>
        <Select
          v-model="dataForm.deviceTypeId"
          @on-change="(e) => changeSel(e, 'deviceTypeId')"
          :clearable="true"
          placeholder="全部"
        >
          <OptionGroup
            :label="cus.value"
            :key="cus.id"
            v-for="cus in dataCenter.deviceType"
          >
            <Option
              :key="cus2.id"
              :value="cus2.id"
              v-for="cus2 in cus.children"
              >{{ cus2.value }}</Option
            >
          </OptionGroup>
        </Select>
      </li>
      <li v-if="userRole.indexOf('m1') > -1">
        <span>监测装置: </span>
        <Select
          v-model="dataForm.zhuangzhiId"
          @on-change="(e) => changeSel(e, 'zhuangzhiId', cityList)"
          :clearable="true"
          placeholder="全部"
        >
          <Option :key="type.id" :value="type.id" v-for="type in cityList">{{
            type.name
          }}</Option>
        </Select>
      </li>
      <li>
        <span>润滑油油品: </span>
        <Select
          v-model="dataForm.oilProductId"
          @on-change="(e) => changeSel(e, 'oilProductId')"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="type.id"
            :value="type.id"
            v-for="type in dataCenter.oilProduct"
            >{{ type.value }}</Option
          >
        </Select>
      </li>
      <!-- <li>
                    <span>所在设备组: </span>
                    <Select v-model="dataForm.workshopId" @on-change="(e)=>changeSel(e,'workshopId')" :clearable="true" placeholder="全部">
                        <Option :key="brand.id" :value="brand.id" v-for="brand in dataCenter.workShop">{{brand.value}}</Option>
                    </Select>
                </li> -->
      <li>
        <span>在线状态: </span>
        <Select
          v-model="dataForm.onLineStatus"
          @on-change="(e) => changeSel(e, 'onLineStatus')"
          :clearable="true"
          placeholder="全部"
        >
          <Option value="ONLINE">在线</Option>
          <Option value="OFFLINE">离线</Option>
        </Select>
      </li>
      <li>
        <span>报警状态: </span>
        <Select
          v-model="dataForm.alarmStatus"
          :disabled="
            !dataForm.onLineStatus || dataForm.onLineStatus === 'OFFLINE'
              ? true
              : false
          "
          @on-change="(e) => changeSel(e, 'alarmStatus')"
          :clearable="true"
          placeholder="全部"
        >
          <Option value="1">正常</Option>
          <Option value="2">异常</Option>
          <Option value="0">报警</Option>
        </Select>
      </li>

      <li class="searchItem">
        <Button class="sels-item" @click="resetData">重置</Button>
      </li>
    </ul>

    <!-- selected -->
    <div class="common-selects selected-margin" v-if="selItems.length">
      <span class="tit">已选:</span>
      <span class="sel" v-for="(item, index) in selItems" :key="index"
        >{{ item.val }}
        <Icon @click="delSelItem(item, index)" type="md-close-circle"
      /></span>
    </div>

    <!-- v-if='dataLists.length' -->
    <div class="common-list list-margin">
      <!-- 美孚管理员 -->
      <Button
        v-nohasPermi="['m3', 'm4']"
        type="primary"
        id="mdadd"
        @click="added()"
        v-if="userRole.indexOf('m') > -1 || userRole.includes('c1')"
      >
        <Icon type="md-add" /> 新增润滑点
      </Button>
      <!-- 列表 -->
      <div class="common-list table-margin">
        <Table
          class="equipmentTable"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <!-- 分页器 -->
      <div class="common-page fr" id="rhlistPage" v-if="pageInfo.total">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="getLists"
          @on-page-size-change="getListsSize"
        >
        </Page>
      </div>
    </div>
    <!-- </Card> -->
    <RhlistDrawer
      :cityList="cityList"
      :showDrawer="showDrawer"
      :closeDrawer="closeDrawer"
      :dataCenter="dataCenter"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :timernum="timernum"
    >
    </RhlistDrawer>
    <Modal
      class="newModal"
      @on-cancel="clearmodel"
      v-model="modal1"
      title="设备证书"
    >
      <div class="u-flex">
        <div>设备证书</div>
        <div class="modu-copy pot" @click="Onecliccopy">一键复制</div>
      </div>
      <div style="margin-top: 10px">
        <div class="u-flex">
          <div class="mod-left">iotProductKey</div>
          <div class="mod-right">
            <div>{{ modeobj.iotProductKey }}</div>
            <div @click="copy(modeobj.iotProductKey)" class="modu-copy pot">
              复制
            </div>
          </div>
        </div>
        <div class="u-flex" style="margin-top: 10px">
          <div class="mod-left">DeviceName</div>
          <div class="mod-right">
            <div>{{ modeobj.oilSiteIotName }}</div>
            <div @click="copy(modeobj.oilSiteIotName)" class="modu-copy pot">
              复制
            </div>
          </div>
        </div>
        <div class="u-flex" style="margin-top: 10px">
          <div class="mod-left">DeviceSecret</div>
          <div class="mod-right">
            <div>{{ modeobj.secret }}</div>
            <div class="modu-copy pot" @click="copy(modeobj.secret)">复制</div>
          </div>
        </div>
      </div>

      <div slot="footer">
        <div>
          <Button @click="clearmodel">关闭</Button>
        </div>
      </div>
    </Modal>
    <Aramcinfig
      :groupAuthorityString="groupAuthorityString"
      :cid="cid"
      v-model="armode1"
    />
    <RhlistVisible
      :zbiaoobj="zbiaoobj"
      :zbtimernum="zbtimernum"
      :oilSiteId="oilSiteId"
      v-model="visiblesShow"
    />
    <!-- <qdcropper/> -->
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import handleSelItem from "@/mixins/handleSelItem";
import RhlistDrawer from "./components/rhlist-drawer.vue";
import Aramcinfig from "./components/rhlist-aramcinfig.vue";
import sizeData from "@/mixins/sizeData";
import toRoleName from "@/mixins/roleName";
import { oilSiteGetList, relatedInfo, sockedDel } from "@/api/business/rhlist";
import { olitypelist } from "@/api/knowledge/device.js";
import RhlistVisible from "./components/rhlistVisible.vue";
import qdcropper from "@/components/qd-cropper/index.vue";
import Base64 from "@/util/encryptlong";
export default {
  name: "equipment-rhlist",
  mixins: [handleSelItem, sizeData, toRoleName],
  components: {
    RhlistDrawer,
    Aramcinfig,
    RhlistVisible,
    qdcropper,
  },
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
      sockedlist: (state) => state.pub.sockedlist,
    }),
  },
  data() {
    return {
      groupAuthorityString: "",
      cityList: [],
      oilSiteId: "",
      visiblesShow: false,
      cid: "",
      armode1: false,
      userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
      vicopy: false,
      visible: false,
      modeobj: {
        oilSiteTypeId: "",
        oilSiteIotName: "",
        secret: "",
      },
      modal1: false,
      userRole: ls.get("userRole"),
      iconImg1: require("@/assets/images/svg/icon-going.svg"),
      iconImg2: require("@/assets/images/svg/icon-warning.svg"),
      iconImg3: require("@/assets/images/svg/icon-error.svg"),
      dataLists: [],
      selItems: [],
      dataForm: {},
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
      },
      showDrawer: false,
      curItemDetail: {},
      selItems: [],
      dataColumn: [
        {
          title: "序号",
          type: "index",
          width: 80,
          fixed: "left",
        },
        {
          title: "润滑点名称",
          key: "name",
          width: 220,
          // sortable: true,
          // ellipsis: true,
          fixed: "left",
          render: (h, params) => {
            return h("div", params.row.name || "-");
          },
        },

        {
          title: "润滑点编号",
          key: "oilSiteIotName",
          // ellipsis: true,
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.oilSiteIotName || "-");
          },
        },
        {
          title: "应用类型",
          key: "application",
          // ellipsis: true,
          width: 150,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.application || "-");
          },
        },
        {
          title: "监测装置",
          key: "zhuangzhiName",
          width: 180,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.zhuangzhiName || "-");
          },
        },
        {
          title: "油品",
          key: "oilProductName",
          width: 130,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.oilProductName || "-");
          },
        },
        {
          title: "绑定网关",
          key: "tranName",
          width: 200,
          render: (h, params) => {
            const gatewayName = params.row.gatewayName;

            return h("div", gatewayName || "-");
          },
        },
        {
          title: "在线状态",
          key: "onLineStatus",
          width: 100,
          render: (h, params) => {
            const item = params.row;
            let show = [];
            if (item && item.onLineStatus === "ONLINE") {
              show = [
                h("div", {
                  style: {
                    marginRight: "6px",
                    background: "#6db400",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    display: "inline-block",
                  },
                }),
                h("span", "在线"),
              ];
            } else {
              show = [
                h("div", {
                  style: {
                    marginRight: "6px",
                    background: "#d8d8d8",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    display: "inline-block",
                  },
                }),
                h("span", "离线"),
              ];
            }
            return h("div", show);
          },
        },
        {
          title: "报警状态",
          key: "alarmStatus",
          align: "left",
          width: 100,
          render: (h, params) => {
            const item = params.row;
            let show = [];
            if (item && +item.alarmStatus === 1) {
              show = [
                h("img", {
                  attrs: {
                    src: this.iconImg1,
                  },
                  style: {
                    width: "51px",
                    verticalAlign: "sub",
                  },
                }),
              ];
            } else if (item && +item.alarmStatus === 2) {
              show = [
                h("img", {
                  attrs: {
                    src: this.iconImg2,
                  },
                  style: {
                    width: "51px",
                    verticalAlign: "sub",
                  },
                }),
              ];
            } else {
              show = [
                h("img", {
                  attrs: {
                    src: this.iconImg3,
                  },
                  style: {
                    width: "51px",
                    verticalAlign: "sub",
                  },
                }),
              ];
            }

            if (item && item.onLineStatus === "ONLINE") return h("div", show);
            else return h("div", "-");
          },
        },
        {
          title: "所属客户",
          key: "consumerName",
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.consumerName || "-");
          },
        },
        {
          title: "所属设备",
          key: "deviceName",
          width: 180,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.deviceName || "-");
          },
        },
        {
          title: "设备类型",
          key: "deviceTypeName",
          width: 180,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.deviceTypeName || "-");
          },
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          width: 200,
          render: (h, params) => {
            let time = params.row.gmtCreate;
            return h("div", time.replace("T", " ") || "-");
          },
        },
        {
          title: "备注",
          key: "gmtCreate",
          width: 200,
          render: (h, params) => {
            let remake = params.row.remake;
            return h("div", remake || "-");
          },
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          fixed: "right",
          width: 250,
          className: "action",
          render: (h, params) => {
            const item = params.row;
            let bo = true;

            let dshow = [];
            let btnarr = [];
            if (item.status === 0) {
              //详情不可见

              btnarr.push(
                h(
                  "span",
                  {
                    class: `config${params.index}`,
                    style: {
                      "text-align": "center !important",

                      "font-weight": "400",
                      color: "#ccc",
                      cursor: "not-allowed",
                    },
                  },
                  "详情"
                )
              );
            } else {
              btnarr.push(
                h(
                  "div",
                  {
                    attrs: {
                      id: `config${params.index}`,
                    },

                    class: `pot config${params.index}`,
                    style: {
                      "text-align": "center !important",

                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    on: {
                      click: (name) => {
                        ls.session.set("rhDetails_" + item.id, item);
                        // this.$router.push(`/business/rhlist/${item.id}`)
                        const routeUrl = this.$router.resolve({
                          path: `/business/rhlist/${item.id}`,
                        });

                        window.open(routeUrl.href, "_blank");
                      },
                    },
                  },
                  "详情"
                )
              );
            }

            if (
              !(
                this.userRole == "m0" ||
                this.userRole == "a0" ||
                this.userRole == "a1" ||
                this.userRole == "c0"
              )
            ) {
              btnarr.push(
                h(
                  "span",
                  {
                    class: "anchorPoint-oilSite-list-edit pot",
                    attrs: {
                      id: `anchorPoint-oilSite-list-edit${params.index}`,
                    },
                    style: {
                      "text-align": "center !important",
                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    on: {
                      click: (name) => {
                        this.editDetail(item);
                      },
                    },
                  },
                  "编辑"
                )
              );

              if (this.userRole.indexOf("m0") == -1) {
                btnarr.push(
                  h(
                    "span",
                    {
                      class: "pot",
                      style: {
                        "text-align": "center !important",

                        "font-weight": "400",
                        color: "#0C479D",
                      },
                      on: {
                        click: (name) => {
                          this.delItemWarning(params.row);
                        },
                      },
                    },
                    "删除"
                  )
                );
              }
              dshow.push(
                h(
                  "DropdownItem",
                  {
                    style: {
                      "text-align": "center !important",
                      "font-size": "12px !important",
                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    nativeOn: {
                      click: (name) => {
                        this.groupAuthorityString = item.groupAuthorityString;
                        this.cid = item.id;
                        this.armode1 = true;
                      },
                    },
                  },
                  "报警配置"
                ),
              );
            }
            if (this.userRole == "m0" && item.groupAuthorityString == "rw") {
              dshow.splice(
                1,
                0,
                h(
                  "DropdownItem",
                  {
                    style: {
                      "text-align": "center !important",
                      "font-size": "12px !important",
                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    nativeOn: {
                      click: (name) => {
                        this.groupAuthorityString = item.groupAuthorityString;
                        this.cid = item.id;
                        this.armode1 = true;
                      },
                    },
                  },
                  "报警配置"
                ),
                h(
                  "DropdownItem",
                  {
                    style: {
                      "text-align": "center !important",
                      "font-size": "12px !important",
                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    nativeOn: {
                      click: async (name) => {
                        let citem = this.sockedlist.find(
                          (e) => e.type == "oil_identifier_show"
                        );
                        this.zbiaoobj = {
                          id: params.row.id,
                          type: citem.type,
                          chinaType: citem.typeName,
                        };
                        let data = await relatedInfo({
                          ...this.zbiaoobj,
                        });

                        if (data.data) {
                          this.zbtimernum = citem.totalTime * (1000 * 60);
                          this.oilSiteId = params.row.id;
                          this.visiblesShow = true;
                        } else {
                          this.$Message.info(data.msg);
                        }
                      },
                    },
                  },
                  "配置客户指标可见"
                )
              );

              btnarr.splice(
                1,
                0,
                h(
                  "span",
                  {
                    class: "anchorPoint-oilSite-list-edit pot",
                    style: {
                      "text-align": "center !important",

                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    on: {
                      click: (name) => {
                        this.editDetail(item);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "span",
                  {
                    class: "pot",
                    style: {
                      "text-align": "center !important",

                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    on: {
                      click: (name) => {
                        this.delItemWarning(params.row);
                      },
                    },
                  },
                  "删除"
                )
              );
            }

            if (this.userRole.includes("m1")) {
              dshow.push(
                h(
                  "DropdownItem",
                  {
                    style: {
                      "text-align": "center !important",
                      "font-size": "12px !important",
                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    nativeOn: {
                      click: async (name) => {
                        let citem = this.sockedlist.find(
                          (e) => e.type == "oil_identifier_show"
                        );
                        this.zbiaoobj = {
                          id: params.row.id,
                          type: citem.type,
                          chinaType: citem.typeName,
                        };
                        let data = await relatedInfo({
                          ...this.zbiaoobj,
                        });

                        if (data.data) {
                          this.zbtimernum = citem.totalTime * (1000 * 60);
                          this.oilSiteId = params.row.id;
                          this.visiblesShow = true;
                        } else {
                          this.$Message.info(data.msg);
                        }
                      },
                    },
                  },
                  "配置客户指标可见"
                )
              );
            }

              if (this.userRole == "m3" || this.userRole == "m4") {
              btnarr = [
                h(
                  "div",
                  {
                    attrs: {
                      id: `config${params.index}`,
                    },

                    class: `pot config${params.index}`,
                    style: {
                      "text-align": "center !important",

                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    on: {
                      click: (name) => {
                        ls.session.set("rhDetails_" + item.id, item);
                        // this.$router.push(`/business/rhlist/${item.id}`)
                        const routeUrl = this.$router.resolve({
                          path: `/business/rhlist/${item.id}`,
                        });

                        window.open(routeUrl.href, "_blank");
                      },
                    },
                  },
                  "详情"
                ),
              
              ];

              dshow = [
                h(
                  "DropdownItem",
                  {
                    style: {
                      "text-align": "center !important",
                      "font-size": "12px !important",
                      "font-weight": "400",
                      color: "#0C479D",
                    },
                    nativeOn: {
                      click: (name) => {
                        this.groupAuthorityString = item.groupAuthorityString;
                        this.cid = item.id;
                        this.armode1 = true;
                      },
                    },
                  },
                  "报警配置"
                ),
              
              ];
            }

            // let divss=h("div")

            if (dshow.length == 0) {
              bo = false;
            }
       
            btnarr = btnarr.flatMap((indx, key) => {
              return [
                indx,
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    },
                  },
                  "|"
                ),
              ];
            });
            let drw = h(
              "Dropdown",
              {
                style: {
                  position: "relative",
                  top: "-4px",
                  left: "1px",
                },
                props: {
                  trigger: "click",
                  // trigger: "hover",
                  transfer: true,
                },
                on: {
                  "on-click": (command) => {
                    //this.handleDropdownCommand(command, params.row);
                  },
                },
              },
              [
                h("a", {}, [
                  h(
                    "span",
                    {
                      class: "drop",
                      style: {
                        "font-size": "28px",
                        "font-weight": 400,
                        color: "#0C479D",
                        position: "relative",
                        top: "-5px",
                      },
                    },
                    "..."
                  ),
                ]),
                h(
                  "DropdownMenu",
                  {
                    slot: "list",
                  },
                  dshow
                ),
              ]
            );
          

            let rh = null;
           

            if (bo) {
              rh = h(
                "div",
                {
                  class: `u-flex menus${params.index}`,
                  id: ``,
                },
                [...btnarr, drw]
              );
            } else {
              btnarr.pop();
              rh = h(
                "div",
                {
                  class: `u-flex menus${params.index}`,
                },
                [...btnarr]
              );
            }

            return rh;
          },
        },
      ],
      showDrawer: false,
      timernum: 0,
      soikobj: {},
      zbiaoobj: {},
      zbtimernum: null,
    };
  },
  created() {
    // 非美孚管理员
    if (this.userRole.indexOf("m1") < 0) {
      this.dataColumn.forEach((res, index) => {
        if (res.title === "初始化状态") this.dataColumn.splice(index, 1);
      });
    }

    // 客户
    if (this.userRole.indexOf("c") > -1) {
      this.dataColumn.forEach((res, index) => {
        if (res.title === "所属客户") this.dataColumn.splice(index, 1);
      });
    }

    // 经销商
    if (this.userRole.indexOf("a") > -1) {
      this.dataColumn.forEach((res, index) => {
        if (res.title === "初始化状态") this.dataColumn.splice(index, 1);
      });
    }

    if (!['c0', 'c1'].includes(this.userRole)) {
      this.$store.dispatch("listCollection", "consumer"); // 客户
    }
    this.$store.dispatch("listCollection", "consumerIndustry"); // 客户行业
    this.$store.dispatch("listCollection", "device"); // 设备
    this.$store.dispatch("listCollection", "deviceType"); // 设备类型
    this.$store.dispatch("listCollection", "workShop"); // 设备组

    this.$store.dispatch("listCollection", "oilProduct"); // 润滑油油品
    this.$store.dispatch("dataCenter", "oilSiteLabel"); // 润滑油标签
  },
  mounted() {
    this.getLists();
    this.init();
  },
  methods: {
    async init() {
      if (!this.userRole.includes("a")) {
        let data1 = await olitypelist({
          current: 1,
          id: "",
          identifiers: [],
          name: "",
          size: 100,
        });

        this.cityList = data1.data.records.map((e) => {
          e.value = e.name;
          return e;
        });
      }

      //  let timernum
      let userRole = this.userRole;
      let item = this.sockedlist.find((e) => e.type == "oil");
      this.soikobj = item;
      this.timernum = item.totalTime * (1000 * 60);
      this.dataColumn = this.dataColumn.map((item) => {
        if (item.title == "操作") {
        
          if (userRole.includes("a") || userRole.includes("c0")) {
            item.width = 100;
          }
        }
        return item;
      });
    },
    clearmodel() {
      this.modal1 = false;
    },
    Onecliccopy() {
      const { oilSiteTypeId, oilSiteIotName, secret } = this.modeobj;
      let text = `
        {
          "iotProductKey":${oilSiteTypeId},
          "DeviceName":${oilSiteIotName},
          "DeviceSecret":${secret}
        }
        `;
      this.copy(text);
    },
    copy(text) {
      let that = this;

      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          function () {
            that.$Message.success("复制成功");
          },
          function () {
            //	copy2(text);
          }
        );
      } else {
        //	copy2(text);
      }
    },

    release(item) {
      this.$Modal.confirm({
        title: item.status == 0 ? `你确定要发布吗` : `你确定要取消发布吗`,
        content: `润滑点名称：${item.name}`,

        onOk: () => {
          let url =
            item.status == 0
              ? `/ocm-oil-site//oil-site/init?id=${item.id}`
              : `/ocm-oil-site//oil-site/stopInit?id=${item.id}`;
          api.axss("get", url).then((res) => {
            if (res.code === "00000") {
              this.$Message.success("操作成功");
              this.curItemDetail = {};
              const finalSize = this.sizeData(
                this.pageInfo.size,
                this.pageInfo.current,
                this.pageInfo.total
              );
              this.getLists(finalSize);
            }
          });
        },
        onCancel: () => {},
      });
      // let url=item.status==0?"未发布":"已经发布"
    },
    delItemWarning(item) {
      this.$Modal.confirm({
        title: `您确定要删除该润滑点？`,
        content: `润滑点名称：${item.name}`,

        onOk: () => {
          this.delItem(item.id);
        },
        onCancel: () => {},
      });
    },
    delItem(id) {
      api.axss("get", `/ocm-oil-site/oil-site/remove?id=${id}`).then((res) => {
        if (res.code === "00000") {
          this.$Message.success("删除成功");
          this.curItemDetail = {};
          const finalSize = this.sizeData(
            this.pageInfo.size,
            this.pageInfo.current,
            this.pageInfo.total
          );
          this.getLists(finalSize);
        }
      });
    },
    async getLists(page) {
      this.$store.state.spinShow = true;
      if (page) this.pageInfo.current = page; //分页处理
      // api.axss(
      //   "post",
      //   "/ocm-oil-site/oil-site/page", {
      //     ...this.pageInfo,
      //     ...this.dataForm
      //   }
      // )

      oilSiteGetList({
        ...this.pageInfo,
        ...this.dataForm,
      }).then((res) => {
        if (res.code === "00000") {
          const datas = res.data;
          this.dataLists = datas.records.map((e) => {
            e.follbo = false;
            return e;
          });
          this.pageInfo.total = datas.total;
          setTimeout(() => {
            this.$store.state.spinShow = false;
          }, 500);
        }
      });
    },
    getListsSize(size) {
      this.pageInfo.size = size;
      this.getLists(1);
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeSel(val, name, arr = this.dataCenter) {
      //选择离线-清空报警状态
      if (name === "onLineStatus" && val === "OFFLINE")
        this.dataForm.alarmStatus = "";
      this.selItems = this.handleSelItem(val, name, arr);

      this.getLists(1);
    },
    changeDate(date, name) {
      this.dataForm.gmtCreateDateStart = date[0];
      this.dataForm.gmtCreateDateEnd = date[1];
      this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      this.getLists(1);
    },
    delSelItem(selItem, index) {
      console.log('selItem',selItem.name,)
      this.dataForm[selItem.name] = null;

      //日期需要单独处理
      if (selItem.name === "date") {
        delete this.dataForm.gmtCreateDateStart;
        delete this.dataForm.gmtCreateDateEnd;
      }

      this.selItems.splice(index, 1);
      this.getLists(1);
    },
    added() {
      this.curItemDetail = {};
      this.showDrawer = true;
    },
    async editDetail(item) {
      let data = await relatedInfo({
        id: item.id,
        type: this.soikobj.type,
        chinaType: this.soikobj.typeName,
      });

      if (data.data) {
        this.curItemDetail = deepcopy(item);
        this.showDrawer = true;
      } else {
        this.$Message.info(data.msg);
      }
    },
    async closeDrawer() {
      this.showDrawer = false;
      if (this.curItemDetail.id) {
        let { data } = await sockedDel({
          id: this.curItemDetail.id,
          type: "oil",
        });
      }
      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.curItemDetail = {};
      });
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
  },
};
</script>
<style>
.ivu-dropdown-menu {
  min-width: 90px;
}
</style>

<style lang='less' scoped>
.equipment-rhlist {
}
</style>
<style lang="less">
//  .ivu-select-dropdown{
//     left: 12px !important;
//   }
.rhicon-img {
  width: 16px;
  height: 16px;
  /* margin-top: 3px; */
  position: relative;
  top: 3.5px;
}

.equipmentTable {
  .ivu-table-tbody {
    td {
      padding: 10px 0;

      .ivu-table-cell {
        span {
          font-size: 14px;
        }
      }
    }

    .ivu-btn {
      &:hover {
        border: 1px solid #ccc;
      }
    }
  }
}

.modu-copy {
  color: #2d8cf0;
  margin-left: 10px;
  font-size: 12px;
}

.mod-left {
  width: 90px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
}

.mod-right {
  font-size: 12px;
  color: #000;
  margin-left: 30px;
  display: flex;
}
</style>